module.exports = __webpack_public_path__ + "static/favicon-f34592b96f1aebd1ee28b42a0320dd0b.ico";